<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "ImgStyle",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'imgStyle:add',
        update: 'imgStyle:update',
        delete: 'imgStyle:delete',
        deleteBatch: 'imgStyle:deleteBatch'
      },
      url: {
        get: '/imgStyle/listByCondition',
        add: '/imgStyle/add',
        update: '/imgStyle/update',
        delete: '/imgStyle/delete/',
        delete_batch: '/imgStyle/deleteBatch',
        status: '/imgStyle/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'styleDetails',
        label: '风格描述',
        show: true,
        width: '',
      },{
        field: 'styleNo',
        label: '风格编号',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '图像风格',
        updateTitle: '图像风格',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'styleDetails',
          label: '风格描述',
          type: 'input',
          placeholder: '风格描述',
          rules: [{message: '请输入风格描述', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'styleNo',
          label: '风格编号',
          type: 'input',
          placeholder: '风格编号',
          rules: [{message: '请输入风格编号', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
